import { render } from "./SFXGallery.vue?vue&type=template&id=6556a342"
import script from "./SFXGallery.vue?vue&type=script&lang=js"
export * from "./SFXGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__